import type { ReactNode } from 'react';

import { FormContext, FormMethodsContext } from './FormContext.tsx';

type FormProviderProps = {
  form: Record<string, unknown>;
  methods: Record<string, unknown>;
  children: ReactNode;
};

function FormProvider({ form, methods, children }: FormProviderProps) {
  return (
    <FormMethodsContext.Provider value={methods}>
      <FormContext.Provider value={form}>{children}</FormContext.Provider>
    </FormMethodsContext.Provider>
  );
}

export default FormProvider;
